import firebase from 'firebase/compat/app';
import "firebase/compat/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from 'firebase/firestore/lite';
import ReactObserver from 'react-event-observer';
import { getFunctions } from 'firebase/functions';

// Firebase config - PR
export const firebaseConfig = {
  apiKey: "AIzaSyCb6SraFwP2uSQAmydlyiCY9TyFd5ek6CI",
  authDomain: "prod-twi.firebaseapp.com",
  projectId: "prod-twi",
  storageBucket: "prod-twi.appspot.com",
  messagingSenderId: "175868174559",
  appId: "1:175868174559:web:449bb8f482f7f88e98096a"
};


export const app = firebase.initializeApp(firebaseConfig);
export const auth = firebase.auth();
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, process.env.REACT_APP_FIREBASE_REGION);

export const firebaseObserver = ReactObserver();
firebase.auth().onAuthStateChanged(function(user) {
  firebaseObserver.publish("authStateChanged", user);
  if (user) {
    user.getIdTokenResult().then(function(data) {
      firebaseObserver.publish("authAdminClaim", data.claims?.admin);
      firebaseObserver.publish("authSuperAdminClaim", data.claims?.superadmin);
      firebaseObserver.publish("authOperatorClaim", data.claims?.operator);
    });
  } else {
    firebaseObserver.publish("authAdminClaim", false);
    firebaseObserver.publish("authSuperAdminClaim", false);
    firebaseObserver.publish("authOperatorClaim", false);
  }
});

// use ReactObserver instead
// export async function isAuth() {
//   await firebase.auth().onAuthStateChanged(function(user) {
//     if (user) {
//       return true;
//     } else {
//       return false;
//     }
//   });
// }

// export async function isAdmin() {
//   await firebase.auth().onAuthStateChanged(function(user) {
//     if (user) {
//       user.getIdTokenResult().then(function(data) {
//         return data.claims?.admin;
//       });
//     } else {
//       return false;
//     }
//   });
// }

// export async function isSuperAdmin() {
//   await firebase.auth().onAuthStateChanged(function(user) {
//     if (user) {
//       user.getIdTokenResult().then(function(data) {
//         return data.claims?.superadmin;
//       });
//     } else {
//       return false;
//     }
//   });
// }
